import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { HEADER_SELECTOR } from "../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../base/base.component";
import { HeaderButton } from "../../../crossconcern/models/header/headerbutton.model";
import {
    HEADER_BUTTON_TYPE_NEW,
    HEADER_BUTTON_TYPE_OTHER
} from "../../../crossconcern/utilities/properties/header.property";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { UserManager } from "../../../business/managers/user.manager";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import {
    BACKOFFICE_LOGIN_ROUTE,
    PRIVATE_CHANGE_PASSWORD_ROUTE
} from "../../../crossconcern/utilities/properties/routename.property";

@Component({
    selector: HEADER_SELECTOR,
    templateUrl: "./header.component.html"
})
export class HeaderComponent extends BaseComponent implements OnInit {

    @Input() public headerButtons: HeaderButton[];
    @Output() public onSidebarToggle: EventEmitter<string> = new EventEmitter();

    public headerButtonTypeNew = HEADER_BUTTON_TYPE_NEW;
    public headerButtonTypeOther = HEADER_BUTTON_TYPE_OTHER;

    public loggedUserEmail: string;

    constructor(protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        protected userManager: UserManager,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
    }

    public ngOnInit(): void {
        this.loggedUserEmail = this.userManager.getLoggedUserEmail();
    }

    public logout() {
        this.userManager.logout();
        this.goToRouteByName(BACKOFFICE_LOGIN_ROUTE);
    }

    public toggleSidebar() {
        this.onSidebarToggle.emit();
    }

    public onProfileClick() {
        this.goToRouteByName(PRIVATE_CHANGE_PASSWORD_ROUTE);
    }
}
